import firebase from 'firebase/compat/app';
import { AngularEnvironment } from "../env";


/**
 * Sign in for internal apps (staff only)
 */
export async function internalSignIn(environment: AngularEnvironment) {

	//
	// If the app is running from a DEV or PROD deployment, then we
	// authenticate using OIDC. Otherwise, use simple Google Auth.
	//
	const provider = environment.name == 'LOCALHOST'
		? new firebase.auth.GoogleAuthProvider
		: new firebase.auth.OAuthProvider('oidc.eforall-workspace');

	const parameters: { [key: string]: string } = {
		prompt: 'select_account',
	};

	//
	// Only support @eforall.org when deployed to prod or dev.
	//
	if (environment.name == 'LOCALHOST') parameters['hd'] = 'eforall.org';

	provider.setCustomParameters(parameters);


	const auth = firebase.auth();

	//
	// Localhost must sign in with a popup because browsers no
	// longer support cross-domain cookies, and "localhost" is
	// not a registered domain within our apps.
	//
	if (environment.name == 'LOCALHOST') {
		await auth.signInWithPopup(provider);
	}
	else {
		await auth.signInWithRedirect(provider);
	}

}